'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _reactI18next = require('react-i18next');

var _reduxForm = require('redux-form');

var _formComponents = require('components/formComponents');

var _components = require('components');

var _auth2 = require('selectors/auth');

var _ForgotPasswordFormValidation = require('./ForgotPasswordFormValidation');

var _ForgotPasswordFormValidation2 = _interopRequireDefault(_ForgotPasswordFormValidation);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _auth3 = require('helpers/auth');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var formSelector = (0, _reduxForm.formValueSelector)('forgotPasswordForm');

var styles = require('./ForgotPasswordForm.scss');

var ForgotPasswordForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loginFormState: state.auth.loginFormState,
    newPasswordValue: formSelector(state, 'newPassword'),
    termsAccepted: state.auth.termsAccepted,
    user: (0, _auth2.getUser)(state)
  };
}, (0, _extends3.default)({}, authActions)), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'forgotPasswordForm',
  propNamespace: 'forgotPasswordForm',
  validate: _ForgotPasswordFormValidation2.default
}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ForgotPasswordForm, _Component);

  function ForgotPasswordForm() {
    var _ref;

    (0, _classCallCheck3.default)(this, ForgotPasswordForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ForgotPasswordForm.__proto__ || (0, _getPrototypeOf2.default)(ForgotPasswordForm)).call.apply(_ref, [this].concat(args)));

    _this.state = { step: _this.props.step };
    return _this;
  }

  (0, _createClass3.default)(ForgotPasswordForm, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.initForm({ userEmail: this.props.passwordEmail });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.passwordEmail !== this.props.passwordEmail) {
        this.initForm({ userEmail: nextProps.passwordEmail });
      }
    }
  }, {
    key: 'getFormHint',
    value: function getFormHint() {
      var _hints;

      var _props = this.props,
          loginFormState = _props.loginFormState,
          t = _props.t;

      var hints = (_hints = {}, (0, _defineProperty3.default)(_hints, _auth3.loginFormStates.reset, t('Your password has expired. You need to create a new password.')), (0, _defineProperty3.default)(_hints, _auth3.loginFormStates.unlock, t('Your account is locked due to too many failed passwords. You need to reset your password to unlock it.')), _hints);
      return hints[loginFormState] || '';
    }
  }, {
    key: 'setSubmit',
    value: function setSubmit(formData) {
      var _this2 = this;

      var _props2 = this.props,
          setNewPassword = _props2.setNewPassword,
          passwordCode = _props2.passwordCode,
          passwordKey = _props2.passwordKey,
          afterSet = _props2.afterSet,
          isNew = _props2.isNew;

      return setNewPassword(passwordCode, passwordKey, (0, _extends3.default)({}, formData, { isNew: isNew })).promise.then(function (resp) {
        _this2.setState({ step: 'afterSet' });
        afterSet((0, _extends3.default)({}, resp.data, formData));
      });
    }
  }, {
    key: 'isWarningHint',
    value: function isWarningHint() {
      var loginFormState = this.props.loginFormState;

      return [_auth3.loginFormStates.reset, _auth3.loginFormStates.unlock].includes(loginFormState);
    }
  }, {
    key: 'initForm',
    value: function initForm(props) {
      this.props.forgotPasswordForm.initialize(props);
    }
  }, {
    key: 'resetSubmit',
    value: function resetSubmit(formData) {
      var _this3 = this;

      var _props3 = this.props,
          resetPassword = _props3.resetPassword,
          changePassword = _props3.changePassword,
          user = _props3.user;

      var promise = user ? changePassword({ userEmail: user.userEmail }).promise : resetPassword(formData).promise;
      return promise.then(function () {
        _this3.setState({ step: 'afterReset' });
      });
    }
  }, {
    key: 'submit',
    value: function submit(formData) {
      var step = this.state.step;

      var submitMethod = this[step + 'Submit'];
      return submitMethod ? submitMethod(formData) : false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props4 = this.props,
          t = _props4.t,
          isNew = _props4.isNew,
          user = _props4.user,
          newPasswordValue = _props4.newPasswordValue,
          showCancel = _props4.showCancel,
          onCancel = _props4.onCancel,
          termsAccepted = _props4.termsAccepted,
          className = _props4.className,
          termsHintClassName = _props4.termsHintClassName,
          _props4$forgotPasswor = _props4.forgotPasswordForm,
          handleSubmit = _props4$forgotPasswor.handleSubmit,
          submitting = _props4$forgotPasswor.submitting,
          invalid = _props4$forgotPasswor.invalid,
          error = _props4$forgotPasswor.error;
      var step = this.state.step;

      var isSubmitDisabled = submitting || step === 'set' && invalid || step === 'reset' && !user && !termsAccepted;
      var hint = this.getFormHint();
      var isWarningHint = this.isWarningHint();

      return _react2.default.createElement(
        'form',
        { onSubmit: handleSubmit(this.submit) },
        step === 'reset' && _react2.default.createElement(
          'div',
          null,
          user ? _react2.default.createElement(
            'div',
            { className: className },
            _react2.default.createElement(
              'p',
              { className: 'hint' },
              t('Press the button to request password changing')
            )
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: className },
              _react2.default.createElement(
                'p',
                { className: 'danger' },
                hint
              ),
              _react2.default.createElement(
                'p',
                { className: (0, _classnames2.default)(styles.hint, 'hint small', (0, _defineProperty3.default)({}, styles.isWarning, isWarningHint)) },
                t('Please enter your email below to initiate the process')
              ),
              _react2.default.createElement(_reduxForm.Field, {
                name: 'userEmail',
                type: 'email',
                fieldClassName: 'width-perc-100',
                placeholder: t('Email') + '*',
                hideLabel: true,
                component: _formComponents.formSimpleTextInput,
                required: true
              })
            ),
            _react2.default.createElement(_components.TermsAcceptance, { className: (0, _classnames2.default)(className, 'margin-top-20'), hintClassName: termsHintClassName })
          )
        ),
        step === 'afterReset' && _react2.default.createElement(
          'div',
          { className: className },
          _react2.default.createElement(
            'h3',
            null,
            t('Password reset - Check your email')
          ),
          _react2.default.createElement(
            'p',
            null,
            t('We have sent you an email with reset instructions. If the email does not arrive soon, check your spam folder. It was sent from mailer@cright.com')
          )
        ),
        step === 'set' && _react2.default.createElement(
          'div',
          { className: className },
          _react2.default.createElement(
            'p',
            { className: 'hint' },
            isNew ? t('Create your own unique password') : t('Please enter your new password')
          ),
          _react2.default.createElement(_reduxForm.Field, {
            name: 'newPassword',
            type: 'password',
            fieldClassName: 'width-perc-100',
            placeholder: (isNew ? t('Password') : t('New password')) + '*',
            hideLabel: true,
            component: _formComponents.formSimpleTextInput,
            autoComplete: 'off',
            required: true
          }),
          _react2.default.createElement(_reduxForm.Field, {
            name: 'confPassword',
            type: 'password',
            fieldClassName: 'width-perc-100',
            placeholder: t('Confirm password') + '*',
            hideLabel: true,
            component: _formComponents.formSimpleTextInput,
            autoComplete: 'off',
            required: true
          }),
          _react2.default.createElement(_components.PasswordValidationTicks, { errors: error, value: newPasswordValue })
        ),
        step === 'afterSet' && _react2.default.createElement(
          'div',
          { className: className },
          _react2.default.createElement(
            'h3',
            null,
            t('Password changed')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: className },
          step !== 'afterReset' && step !== 'afterSet' && _react2.default.createElement(
            _components.Button,
            {
              type: 'submit',
              className: 'btn-primary wide margin-top-10 margin-left-10 pull-right',
              disabled: isSubmitDisabled
            },
            step === 'reset' ? t('Send') : t('Ok'),
            submitting && _react2.default.createElement(_components.Loader, { mask: true })
          ),
          step === 'set' && !isNew && _react2.default.createElement(
            'button',
            { type: 'button', className: 'btn btn-default wide margin-top-10 pull-right', onClick: function onClick() {
                return _this4.setState({ step: 'reset' });
              } },
            t('Cancel')
          ),
          showCancel && _react2.default.createElement(
            'button',
            { type: 'button', className: 'btn btn-default margin-top-10', onClick: onCancel },
            step === 'afterReset' ? t('Ok') : t('Cancel')
          )
        )
      );
    }
  }]);
  return ForgotPasswordForm;
}(_react.Component), _class3.propTypes = {
  afterSet: _propTypes2.default.func,
  changePassword: _propTypes2.default.func,
  className: _propTypes2.default.string,
  forgotPasswordForm: _propTypes2.default.object,
  isNew: _propTypes2.default.bool,
  loginFormState: _propTypes2.default.string,
  newPasswordValue: _propTypes2.default.string,
  onCancel: _propTypes2.default.func,
  passwordCode: _propTypes2.default.string,
  passwordEmail: _propTypes2.default.string,
  passwordKey: _propTypes2.default.string,
  resetPassword: _propTypes2.default.func,
  setNewPassword: _propTypes2.default.func,
  showCancel: _propTypes2.default.bool,
  step: _propTypes2.default.string,
  t: _propTypes2.default.func,
  termsAccepted: _propTypes2.default.bool,
  termsHintClassName: _propTypes2.default.string,
  user: _propTypes2.default.object
}, _class3.defaultProps = {
  onCancel: function onCancel() {},
  step: 'reset'
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'setSubmit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setSubmit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetSubmit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'resetSubmit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = ForgotPasswordForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ForgotPassword/ForgotPasswordForm.js
// module id = 2009
// module chunks = 1